import React from 'react';

// Retained MedCall FileIconSvg, Ant DownloadOutlined and Font Awesome file-excel.
export const Medcall2ReportIcon = () => (
  <svg aria-hidden="true" width="14" height="17" viewBox="0 0 14 17" fill="none">
    <rect width="14" height="17" rx="2" fill="currentColor" />
    <line x1="2" y1="5.5" x2="12" y2="5.5" stroke="white" />
    <line x1="2" y1="8.5" x2="12" y2="8.5" stroke="white" />
    <line x1="2" y1="11.5" x2="7" y2="11.5" stroke="white" />
  </svg>
);

export const Medcall2ReportDownloadIcon = () => (
  <svg aria-hidden="true" width="20" height="20" viewBox="64 64 896 896" fill="currentColor">
    <path d="M505.7 661a8 8 0 0012.6 0l112-141.7c4.1-5.2.4-12.9-6.3-12.9h-74.1V168c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v338.3H400c-6.7 0-10.4 7.7-6.3 12.9l112 141.8zM878 626h-60c-4.4 0-8 3.6-8 8v154H214V634c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v198c0 17.7 14.3 32 32 32h684c17.7 0 32-14.3 32-32V634c0-4.4-3.6-8-8-8z" />
  </svg>
);

export const Medcall2ReportExcelIcon = () => (
  <svg aria-hidden="true" width="18" height="24" viewBox="0 0 384 512" fill="currentColor">
    <path d="M64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-288-128 0c-17.7 0-32-14.3-32-32L224 0 64 0zM256 0l0 128 128 0L256 0zM155.7 250.2L192 302.1l36.3-51.9c7.6-10.9 22.6-13.5 33.4-5.9s13.5 22.6 5.9 33.4L221.3 344l46.4 66.2c7.6 10.9 5 25.8-5.9 33.4s-25.8 5-33.4-5.9L192 385.8l-36.3 51.9c-7.6 10.9-22.6 13.5-33.4 5.9s-13.5-22.6-5.9-33.4L162.7 344l-46.4-66.2c-7.6-10.9-5-25.8 5.9-33.4s25.8-5 33.4 5.9z" />
  </svg>
);
